module.exports = __webpack_public_path__ + "d1b6e3f1ebbb3a29d4ed2ce92608b9c1.png";